import { conditionalRender } from "src/utils/conditional-render";
import useDefaultSearchCarousels from "src/hooks/useDefaultSearchCarousels";
import { ShopType as SCShopType } from "src/types/graphql.d";
import { DefaultResult } from "./DefaultResult";
import { DefaultResultsWrapper } from "../SearchResults.styled";
import { DefaultResultsSkeleton } from "./DefaultResultsSkeleton";
import { SearchResultsDispatchContext } from "../search-results.context";
import { useContext } from "react";
import { ShopType } from "src/utils/genderLocale/genderLocale";
import { useShopTypeContext } from "src/hooks/context/use-shop-type-context";

function DefaultResults() {
  const { currentShopType } = useShopTypeContext();
  const { onSearchViewAllBrandsClick, onSearchRecommendationClick } =
    useContext(SearchResultsDispatchContext);
  const result = useDefaultSearchCarousels({
    shop_type:
      currentShopType === ShopType.All
        ? SCShopType.Women
        : (currentShopType as SCShopType),
  });

  const component = conditionalRender({
    currentValue: result,
    defaultComponent: <DefaultResultsSkeleton />,
    rules: [
      {
        condition: ({ error }) => !!error,
        component: null,
      },
      {
        condition: ({ loading, data }) =>
          loading &&
          !!(
            !data?.defaultSearchCarousels?.brand_carousels.length &&
            !data?.defaultSearchCarousels?.edit_carousels.length
          ),
        component: <DefaultResultsSkeleton />,
      },
      {
        condition: ({ data }) =>
          !!(
            data?.defaultSearchCarousels?.brand_carousels.length ||
            data?.defaultSearchCarousels?.edit_carousels.length
          ),
        component: (
          <DefaultResultsWrapper>
            {result.data?.defaultSearchCarousels?.brand_carousels.length
              ? result.data?.defaultSearchCarousels?.brand_carousels.map(
                  (brandsCarousel) => (
                    <DefaultResult
                      key={`${brandsCarousel.title}-${brandsCarousel.position}`}
                      data={brandsCarousel}
                      onViewAllClick={onSearchViewAllBrandsClick}
                      onRecommendationClick={onSearchRecommendationClick}
                    />
                  )
                )
              : null}
            {result.data?.defaultSearchCarousels?.edit_carousels.length
              ? result.data?.defaultSearchCarousels?.edit_carousels.map(
                  (editCarousel) => (
                    <DefaultResult
                      key={`${editCarousel.title}-${editCarousel.position}`}
                      data={editCarousel}
                      onRecommendationClick={onSearchRecommendationClick}
                    />
                  )
                )
              : null}
          </DefaultResultsWrapper>
        ),
      },
    ],
  });

  return <>{component}</>;
}

export { DefaultResults };
